import axios from "../../utils/axios";
import { saveAs } from "file-saver";
import { b64toBlob } from "./server-api.utils";

export const getTokenData = async (token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_SERVER}/api/v1/transactions/${token}`
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateTransactionWithSignedData = async (data) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BACKEND_SERVER}/api/v1/transactions/cert`,
      data
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendSignedDataToIntegration = async (data) => {
  try {
    //const response = await axios.post(`${process.env.REACT_APP_BACKEND_SERVER}/api/v2/epotpis/sendSignedDataToPadesAPI`, data);
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_SERVER}/api/v1/transactions/sendSignedDataToIntegration`,
      data
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchCurrentUser = async (token) => {
  try {
    const response = await axios.get(`/auth/current_user/?token=${token}`);

    return response.data;
  } catch (error) {
    // let data = null
    // if(error.response && error.response.data) {
    //   data = error.response.data.error
    // }

    throw error;
  }
};

export const getCloudUserInfo = async (selectedTsp, user, token) => {
  try {
    const userInfoResponse = await axios.post(selectedTsp.userInfoUrl, {
        accessToken: user.accessToken,
        oib: user.oib,
        accessLevel: user.accessLevel
      })
    const cloudUser = userInfoResponse?.data || null;
      
    return cloudUser ;
   
  } catch (error) {
    console.log("error", error);

    throw error;
  }
};

export const fetchTsp = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_SERVER}/api/v1/providers`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTransactionDataByVerificationCode = async (
  verificationCode
) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_SERVER}/api/v1/transactions/document/${verificationCode}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const validateDocumentSignature = async (params) => {
  try {
    const { base64Document, fileName } = params;
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_SERVER}/api/v1/validate/validateDocumentSignature`,
      { base64Document, name: fileName }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const generateAndSavePDFReport = async (params) => {
  try {
    const { documentDetails, numOfSignatures, numOfValidSignatures, fileName } =
      params;
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_SERVER}/api/v1/validate/getPDFReport`,
      { numOfSignatures, numOfValidSignatures, documentDetails, fileName }
    );
    const { timestampedDocument } = response.data;
    const pdfBlob = b64toBlob(timestampedDocument, "application/pdf");
    saveAs(pdfBlob, `report.pdf`);
    return true;
  } catch (error) {
    // if (error.response) {
    //   const { id, message } = error.response.data.error
    //   throw new CustomError(error.message, { id, message, code: 24}) // ddati grešku 24 Greška prilikom izrade PDF izvještaja
    // }
    //  throw new Error('Došlo je do greške')
    throw error;
  }
};

export const prepareSigningData = async (data) => {
  try {
    //const { userCertificate, documents, mimetype} = data
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_SERVER}/api/v1/cloud/prepareSigningData`,
      data
    );
    const { userCertificate, documents, mimetype } = response.data;

    const docs = documents.map(doc => ({
      hash: doc.hash,
      preparedHash: doc.preparedHash,
      mimetype: doc.mimetype,
      mimeType: doc.mimetype,
      verificationCode: doc.verificationCode,
      timeStamp: doc.timeStamp
    }))
    

    return { userCertificate, documents: docs, mimetype };
  } catch (error) {
    throw error;
  }
};
